import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "CategoryFilterSection-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "CategoryFilterSection-toggle" }, null, -1)
const _hoisted_3 = { class: "CategoryFilterSection-collapsable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({'CategoryFilterSection': true, 'is-open': !_ctx.collapsedSection})
  }, [
    _createElementVNode("div", {
      class: "CategoryFilterSection-heading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSectionCollapse()))
    }, [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.section.title), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.data, (control, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.controlType), {
          key: control.name ?? control.nameMin,
          data: control,
          hidden: !_ctx.allVisible && index >= _ctx.visibleCount
        }, null, 8, ["data", "hidden"]))
      }), 128)),
      (_ctx.getHiddenCount())
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "CategoryFilterSection-more",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleVisibility()))
          }, _toDisplayString(_ctx.allVisible ? _ctx.showLessLabel : `${_ctx.showMoreLabel} (${_ctx.getHiddenCount()})`), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}